import {
  DataExtractionValueText,
  __typename as textValueTypename,
} from './DataExtractionValueText';
import {
  DataExtractionValueSingleSelect,
  __typename as singleSelectValueTypename,
} from './DataExtractionValueSingleSelect';
import {
  DataExtractionValueMultipleSelect,
  __typename as multiSelectValueTypename,
} from './DataExtractionValueMultipleSelect';
import {
  DataExtractionValueBase,
  __typename as baseValueTypename,
} from './DataExtractionValueBase';

import { __typename as headerFieldTypename } from './DataExtractionFieldHeader';
import { __typename as textFieldTypename } from './DataExtractionFieldText';
import { __typename as singleSelectFieldTypename } from './DataExtractionFieldSingleSelect';
import { __typename as multiSelectFieldTypename } from './DataExtractionFieldMultipleSelect';

const typenameToClassProtoMap = {
  [baseValueTypename]: DataExtractionValueBase,
  [textValueTypename]: DataExtractionValueText,
  [singleSelectValueTypename]: DataExtractionValueSingleSelect,
  [multiSelectValueTypename]: DataExtractionValueMultipleSelect,
};

const fieldTypeToValueType = {
  [headerFieldTypename]: baseValueTypename,
  [textFieldTypename]: textValueTypename,
  [singleSelectFieldTypename]: singleSelectValueTypename,
  [multiSelectFieldTypename]: multiSelectValueTypename,
};

export function createDataExtractionValue(data) {
  let typename = data.__typename;
  if (data.field) {
    typename = fieldTypeToValueType[data.field?.__typename];
  }
  if (!typename) {
    throw new Error('__typename field required to convert data');
  }
  const classProto = typenameToClassProtoMap[typename];
  if (!classProto) {
    throw new Error(
      `__typename "${typename}" has not been registered`
    );
  }
  return new classProto(data);
}

export function createDataExtractionValueInput(value) {
  return {
    value: value.value,
    valueArr: value.valueArr,
  };
}
